/** Terminal, cabinet and the public site (P6). */
export default {
  nav: { accounts: "Accounts", terminal: "Terminal", programs: "Programs", faq: "FAQ", settings: "Settings", signIn: "Sign in" },
  markets: { crypto: "Crypto", fx: "FX / CFD", futures: "Futures" },
  common: { replay: "REPLAY", noData: "No data", loading: "Loading…", close: "Close", more: "More", less: "Less", none: "—", back: "Back" },
  status: { LIVE: "Live", degraded: "Degraded", closed: "Market closed", connecting: "Connecting…", offline: "Offline — reconnecting" },
  terminal: {
    title: "Terminal",
    account: "Account",
    instrument: "Instrument",
    search: "Search instruments",
    searchHint: "Press / to search",
    noAccount: "Open an account first to trade.",
    toAccounts: "Go to accounts",
    layout: "Layout",
    layouts: { standard: "Standard", chart: "Chart focus", dom: "DOM / ladder" },
    book: "Order book",
    tape: "Time & sales",
    ladder: "DOM",
    step: "Step",
    price: "Price",
    size: "Size",
    time: "Time",
    bid: "Bid",
    ask: "Ask",
    spread: "Spread",
    mark: "Mark",
    last: "Last",
    hotkeys: "Hotkeys",
    hk: { buy: "Market buy", sell: "Market sell", cancel: "Cancel all orders", flatten: "Flatten", search: "Search", sheet: "Keys and gestures", close: "Close a panel" },
    ladderHint: "Click a bid cell to buy at that price, an ask cell to sell; your orders are shown beside the price.",
    phone: {
      amount: "Amount, USD",
      markets: "Markets",
      all: "All",
      recent: "Recent",
      favorites: "Favorites",
      star: "Add to favorites",
      unstar: "Remove from favorites",
      stats: "Market stats",
      account: "Account",
      closeAll: "Close all",
      noResults: "Nothing found. Try a ticker: BTC, EUR, GOLD.",
    },
    cme: "CME market data needs the subscriber agreement first.",
    signCme: "Review and sign",
    groups: { crypto: "Crypto perps", currency: "Currencies", metal: "Metals", energy: "Energy", index: "Indices", stock: "Stocks", futures: "Futures" },
    kinds: { perp: "Perp", fx: "FX", cfd: "CFD", future: "Future" },
    accountSize: "Size {v}",
    accountEquity: "equity {v}",
    allAccounts: "All accounts",
    feed: {
      label: {
        live: "Live",
        connecting: "Connecting…",
        offline: "Offline",
        waiting: "Waiting for data",
        syncing: "Syncing",
        stale: "Delayed",
        closed: "Market closed",
        cme: "Agreement needed",
        licence: "No data licence",
        noSource: "No data",
        denied: "No access",
      },
      why: {
        live: "Prices and the order book stream in real time.",
        connecting: "Connecting to the market stream.",
        offline: "The connection to the market stream dropped.",
        waiting: "The feed for this market has not sent anything yet.",
        syncing: "The order book is being rebuilt from the exchange — usually a few seconds.",
        stale: "The exchange has not updated the book for a few seconds, so prices may lag.",
        closed: "The exchange session is closed; prices resume at the open.",
        cme: "CME asks every user to accept its subscriber agreement before futures data is shown.",
        licence: "Live CME futures data needs an exchange data licence, which this environment does not have yet.",
        noSource: "No data source is connected for this market right now.",
        denied: "This account cannot receive data for this market.",
      },
      todo: {
        offline: "It reconnects on its own; your orders stay as they are.",
        stale: "It resyncs on its own; trade with care until the badge says Live.",
        closed: "Pick an instrument whose market is open.",
        cme: "Review and sign the agreement above the chart.",
        licence: "Trade crypto or FX meanwhile: switch the account at the top left.",
        noSource: "Pick another instrument or check back later.",
        denied: "Switch to another account.",
      },
      emptyBook: "No depth yet",
      emptyBookText: "The book fills in as the exchange sends its levels.",
      emptyTape: "No trades yet",
      emptyTapeText: "Prints appear here as they happen.",
      emptyChart: "No price history yet",
      emptyChartText: "Candles start with the first trades.",
      opensAt: "Opens {time}",
      proxy: "Reference price",
      proxyWhy: "Price from a reference market (no CME data licence).",
      proxyRef: { index: "Reference: the underlying index.", spot: "Reference: the spot price.", front_month: "Reference: the front-month price." },
    },
    keys: {
      title: "Keyboard and mouse",
      armed: "Trading keys on",
      trading: "Trading keys",
      off: "Off: turn them on to trade from the keyboard.",
      anywhere: "Anywhere",
      chart: "On the chart",
      armHint: "Trading keys: B buy, S sell at market, X cancel all, F flatten",
      gestures: {
        limit: "Shift+click: a limit order at the price",
        stop: "Alt+click: a stop order at the price",
        drag: "Drag an order line to move it",
        bracket: "Drag from the position for a take profit or a stop loss",
        zoom: "Wheel: zoom",
        scale: "Drag the price scale to stretch it, double-click to reset",
      },
    },
    noMatch: "Nothing found",
  },
  chart: {
    quick: "Quick trade",
    quickHide: "Fold quick trade",
    tvLoading: "Loading the TradingView chart",
    tf: "Timeframe",
    layers: "Layers",
    heatmap: "Heatmap",
    profile: "Volume profile",
    bubbles: "Big trades",
    vwap: "VWAP",
    ema: "EMA",
    bb: "Bollinger",
    volume: "Volume",
    gamma: "Gamma levels",
    gammaNone: "Options gamma is available for BTC and ETH",
    gammaLoading: "Loading options…",
    gammaInfo: "Deribit options · {n} expiries · {time}",
    callWall: "Call wall",
    putWall: "Put wall",
    flip: "Gamma flip",
    settings: "Settings",
    emaFast: "EMA fast",
    emaSlow: "EMA slow",
    bbPeriod: "Bollinger period",
    bbWidth: "Bollinger width, σ",
    reset: "Reset view",
    more: "More",
    buyMkt: "Buy",
    sellMkt: "Sell",
    qty: "Quantity",
    long: "LONG",
    short: "SHORT",
    tp: "TP",
    sl: "SL",
    lmt: "LMT",
    stp: "STP",
    plus: "Order at {price}",
    buyLimit: "Buy limit {qty} @ {price}",
    sellLimit: "Sell limit {qty} @ {price}",
    buyStop: "Buy stop {qty} @ {price}",
    sellStop: "Sell stop {qty} @ {price}",
    help: "Shift+click: limit · Alt+click: stop · drag a line to move it · drag from the position for TP/SL · wheel: zoom · drag the price scale to stretch it, double-click to reset",
    heatNote: "The heatmap and big trades are recorded while the chart is open.",
    view: "Chart view",
    views: { desk: "Our chart", deskShort: "Ours", tv: "TradingView" },
    tvNote: "Prices here come from TradingView and may differ from the prices your orders fill at.",
    tvBy: "Chart by TradingView",
    tvHint: "Intervals, indicators and drawing tools are in the TradingView toolbar",
    older: "Loading earlier history…",
    olderBusy: "History is busy — trying again in a few seconds",
    look: {
      title: "Look",
      theme: "Theme",
      themes: { obsidian: "Funded Lime", midnight: "Midnight", graphite: "Graphite", classic: "Classic", aurora: "Aurora", mono: "Mono", paper: "Paper" },
      candles: "Candles",
      styles: { filled: "Filled", hollow: "Hollow", bars: "Bars", heikin: "Heikin-Ashi" },
      background: "Background",
      bgModes: { solid: "Solid", gradient: "Gradient", glow: "Glow", dots: "Dots" },
      colors: { up: "Up", down: "Down", background: "Background" },
      grid: "Grid",
      watermark: "Symbol watermark",
      reset: "Reset look",
    },
  },
  pro: {
    openInterest: "Open interest",
    funding: "Funding",
    fundingValue: "{rate} / {h} h",
    mark: "Mark",
    change24h: "24h change",
    high24h: "24h high",
    low24h: "24h low",
    volume24h: "24h volume",
    spread: "Spread",
    total: "Total",
    long: "Buy / Long",
    short: "Sell / Short",
    available: "Available to trade",
    mid: "Mid",
    sizePct: "Size, % of buying power",
    tpsl: "Take profit / stop loss",
    submitLong: "Buy {qty} {base}",
    submitShort: "Sell {qty} {base}",
    orderValue: "Order value",
    entry: "Est. entry",
    maxSize: "Max size",
    riskAtStop: "Risk at stop",
    account: "Account",
  },
  ticket: {
    title: "Order",
    costDetails: "Cost details",
    buy: "Buy",
    sell: "Sell",
    type: "Type",
    types: { market: "Market", limit: "Limit", stop: "Stop", stop_limit: "Stop limit" },
    qty: "Quantity",
    limitPx: "Limit price",
    stopPx: "Stop price",
    tif: "Time in force",
    reduceOnly: "Reduce only",
    postOnly: "Post only",
    bracket: "Take profit / stop loss",
    tp: "Take profit",
    sl: "Stop loss",
    risk: "Risk if the stop is hit",
    riskOfBalance: "{amount} · {pct} of balance",
    sizeFromRisk: "Size from risk, %",
    apply: "Apply",
    noStop: "Add a stop loss to see the risk before sending.",
    submit: "{side} {qty} {symbol}",
    submitted: "Sent — waiting for the engine",
    rejected: "Rejected: {code}",
    filled: "Filled {qty} @ {px}",
    realized: "P&L {v}",
    side: "Side",
    max: "Max",
    lots: "lots",
    maxNow: "max {qty} {base} at {lev}×",
    amountUsd: "Amount, USD",
    unit: "Unit",
    position: "Position",
    tpslIn: "TP / SL in",
    modes: { price: "Price" },
    slRequired: "This program needs a stop loss on every order.",
    marginAt: "Margin at {lev}×",
    tradingFee: "Trading fee",
    leverageFee: "Leverage fee",
    tradingFeeAt: "Trading fee {rate}",
    leverageFeeAt: "Leverage fee {rate}",
    totalCost: "Total to open",
    freeMargin: "Free margin",
    powerHint: "Free margin × {lev}× leverage",
    liqEst: "Est. liquidation",
    liqNote: "Liquidation is an estimate: the price where equity falls to the maintenance margin ({rate} of notional), other positions held as they are. Leverage does not move it.",
    why: {
      inactive: "The account is {status}",
      closed: "The market is closed",
      noPrice: "Waiting for a price",
      noLimit: "Enter the limit price",
      noStop: "Enter the stop price",
      noSize: "Enter a size",
      belowMin: "The smallest size is {min} {base}",
      overMax: "Over the buying power at {lev}×: at most {qty} {base}",
      reduceMax: "Reduce only: at most {qty} {base}",
      tpSide: "Take profit must be {dir} the entry price",
      slSide: "Stop loss must be {dir} the entry price",
      above: "above",
      below: "below",
    },
    results: "Order results",
    sending: "Sending…",
    working: "Working — waits for its price",
    refused: "Refused: {why}",
    actionFailed: "Not done",
    reasons: {
      INSUFFICIENT_MARGIN: "not enough free margin",
      REDUCE_ONLY: "reduce-only would open a position",
      NO_LIQUIDITY: "no liquidity in the book",
      FOK_NOT_FILLED: "could not fill in full",
      POST_ONLY_WOULD_TAKE: "post-only would take liquidity",
      IOC_REMAINDER: "the rest was cancelled (immediate or cancel)",
      POSITION_LIMIT: "over the program position limit",
      MAX_OPEN_POSITIONS: "too many open positions",
      STOP_LOSS_REQUIRED: "this program needs a stop loss",
      INVALID_BRACKET: "take-profit or stop-loss on the wrong side of the price",
      FLAT_BY_TIME: "positions close at the program's flat time — new ones from the next session",
      WEEKEND_CLOSED: "the program closes FX / CFD for the weekend — new positions from Sunday 17:00 New York",
      NEWS_WINDOW: "high-impact news window — you can close, not open or add",
      INSTRUMENT_NOT_ALLOWED: "this instrument is not in the program",
      ACCOUNT_HALTED: "trading on this account has stopped",
      ROLL_WINDOW: "the contract is rolling over",
      OCO: "the other bracket leg filled",
      LEVERAGE_OUT_OF_RANGE: "leverage outside the allowed range",
      LEVERAGE_INSUFFICIENT_MARGIN: "open positions need more margin at that leverage",
    },
    leverage: {
      title: "Leverage",
      unavailable: "Leverage cannot be changed here yet",
      forInstrument: "for {symbol}",
      forAccount: "for the whole account",
      less: "Less",
      more: "More",
      margin: "Margin for the size in the ticket",
      noSize: "set a size",
      maxAt: "Max size at {v}×",
      apply: "Set {v}×",
      pending: "Setting {v}×…",
      applied: "Leverage is {v}×",
      range: "A whole number from {min}× to {max}×",
      marginUsed: "Margin used",
      liqSame: "Leverage changes the margin, not the liquidation price.",
      needsMargin: "At {v}× the open positions need {need} of margin; equity is {equity}.",
      refused: "Not changed: {why}",
      noAnswer: "the engine did not answer, the leverage stays as it was",
      cancel: "Cancel",
    },
  },
  blotter: {
    positions: "Positions",
    orders: "Orders",
    fills: "Fills",
    trades: "Trades",
    instrument: "Instrument",
    side: "Side",
    qty: "Qty",
    avgPx: "Avg price",
    markPx: "Price",
    upnl: "Unrealized P&L",
    rpnl: "Realized P&L",
    type: "Type",
    price: "Price",
    status: "Status",
    filled: "Filled",
    fee: "Fee",
    liquidity: "Liquidity",
    time: "Time",
    entry: "Entry",
    exit: "Exit",
    pnl: "P&L",
    cancel: "Cancel",
    close: "Close",
    flatten: "Flatten all",
    cancelAll: "Cancel all",
    empty: "Nothing yet",
    why: "Why here",
    emptyTitle: { positions: "No open positions", orders: "No working orders", fills: "No fills yet", trades: "No closed trades yet" },
    emptyText: {
      positions: "A position you open from the ticket, the chart or the ladder shows here with its live P&L.",
      orders: "Limit and stop orders wait here until they fill or you cancel them.",
      fills: "Every execution, with the market at that moment (Why here).",
      trades: "A round trip shows here once its position is closed.",
    },
    upnlHint: "Before fees, at the price the engine values the position (the same on the chart)",
    leverageFee: "Leverage fee",
    marginAt: "Margin · {lev}×",
    leverageFeeHint: "Part of the fee: the charge for trading with leverage",
    snapshot: {
      title: "Market at the fill",
      model: "Fill model",
      models: { walk: "walked the book", queue: "queue position reached", trade_through: "price traded through", quote: "against the quote", tiers: "synthetic depth" },
      latency: "Latency",
      quoteAge: "Quote age",
      policy: "Execution policy",
      book: "Book (top levels)",
    },
    long: "Long",
    short: "Short",
    buy: "Buy",
    sell: "Sell",
  },
  risk: {
    title: "Risk",
    dll: "Daily loss left",
    ml: "Max loss left",
    target: "Target",
    days: "Trading days",
    floor: "floor {v}",
    limit: "limit {v}",
    near: "Close to a limit: {rule} has {left} left.",
    paused: "Trading is paused until the next session (daily loss).",
    breached: "This account is stopped: a program rule was broken. Trading is closed; see Breaches.",
    passed: "Phase passed. The next phase opens automatically.",
    practice: "Practice account — no program rules.",
    microShare: "Profit from micro-scalps",
    microHint: "limit {max} % · trades under {sec} s",
    microHeld: "The target waits: {share} % of the profit comes from trades held under {sec} s (limit {max} %). Keep trading with longer trades — this is not a breach.",
    microPayout: "Payouts wait: {share} % of the profit since the last payout comes from trades held under {sec} s (limit {max} %).",
    streak: "Profitable days in a row",
    streakHint: "each ≥ {bar} · needed for a payout",
    status: "Account",
  },
  accounts: {
    emptyLead: "Pick a challenge, trade the live book, get paid.",
    step1: "Choose a challenge",
    step1Note: "Size, rules and price before you pay.",
    step2: "Trade the live book",
    step2Note: "Fills in 10–30 ms, every fill explained.",
    step3: "Get paid up to 90 %",
    step3Note: "Rewards on demand once you pass.",
    pnlTotal: "P&L since start",
    count: "Accounts",
    active: "Active",
    type: "Type",
    size: "Account size",
    startFree: "Buy the challenge",
    allPrograms: "All programs and options",
    title: "Accounts",
    lead: "Every account you trade, with its equity and where it stands.",
    total: "Total equity across your accounts",
    sinceStart: "since start",
    emptyTitle: "Your desk is empty",
    newTitle: "Open an account",
    empty: "No accounts yet. Buy a challenge to start.",
    practice: "Practice",
    challenge: "Challenge",
    funded: "Funded",
    startChallenge: "Start a challenge",
    balance: "Balance",
    equity: "Equity",
    open: "Open",
    trade: "Trade",
    program: "Program",
    phase: "Phase",
    created: "Started",
    chooseMarket: "Market",
    chooseProgram: "Program",
    start: "Start",
  },
  dashboard: {
    monthNet: "Month",
    tradingDays: "Trading days",
    greenDays: "Green days",
    week: "Week",
    fills: "{n} fills",
    daysN: "{n} days",
    overview: "Overview",
    targetOf: "{progress} of {amount}",
    prevMonth: "Previous month",
    nextMonth: "Next month",
    equityCurve: "Equity",
    rules: "Rules of this version",
    version: "Version {n} · {hash}",
    trades: "Trades",
    calendar: "Calendar",
    breaches: "Breaches",
    certificates: "Certificates",
    history: "History",
    stepper: "Phases",
    current: "current",
    realized: "Realized P&L",
    fees: "Fees",
    openTerminal: "Open terminal",
    noTrades: "No closed trades yet",
    certificate: "Certificate",
    viewCertificate: "Open certificate",
    noCertificates: "A certificate appears when a phase is passed.",
    dayNet: "{v} net · {n} fills",
    weekdays: "Mon,Tue,Wed,Thu,Fri,Sat,Sun",
  },
  certificate: {
    heading: "Certificate of achievement",
    body: "{name} passed {phase} of {program} (version {version}).",
    balance: "Closing balance {balance} on a {start} account.",
    days: "{n} trading days.",
    issued: "Issued {date} · ID {id}",
    demo: "Evaluation on a simulated account. This certificate is not an offer of a funded-trader contract.",
    print: "Print",
  },
  cme: {
    title: "CME market data — subscriber agreement",
    frame: "The final agreement text approved by CME is shown here once the market-data licence is in place.",
    intro: "Before futures data is shown, CME requires each user to accept the subscriber agreement and to say whether they are a professional.",
    q1: "Are you registered with a securities or futures regulator?",
    q2: "Do you trade for anyone other than yourself?",
    q3: "Do you use the data for a business?",
    no: "No",
    yes: "Yes",
    pro: "Professional subscribers are not supported yet.",
    name: "Full name as a signature",
    sign: "Sign as non-professional",
    signed: "Signed",
  },
  settings: {
    title: "Settings",
    lead: "How the terminal behaves for you, and the agreements market data needs.",
    trading: "Trading",
    data: "Market data",
    defaultQty: "Default quantity",
    confirm: "Ask before sending an order",
    confirmNote: "One more confirmation before each order leaves the ticket.",
    hotkeysOn: "Trading hotkeys",
    hotkeysNote: "Keyboard shortcuts in the terminal: market buy and sell, cancel all, flatten, search.",
    saved: "Saved",
    cmeNote: "Needed before futures data is shown. Takes a minute.",
    account: "Account and sign-in",
    mfaOff: "Off — protect sign-in and payouts with a second factor.",
    mfaSetUp: "Set up",
    profile: "Profile and password",
    edit: "Edit",
    notifications: "E-mail notifications",
    accountEmails: "E-mails about my accounts",
    accountEmailsNote: "Account ready, phase passed, funded account, breach. Receipts, payouts, withdrawals and support answers always come.",
  },
  site: {
    heroTitle: "Your own prop desk across crypto, FX and futures",
    heroBody: "One terminal, one rule book per program, every fill explained. Simulated trading on real market data.",
    cta: "See programs",
    signIn: "Sign in",
    markets: "Three markets, one platform",
    marketText: {
      crypto: "Perpetuals on a live order book, real funding.",
      fx: "Majors and gold with real spreads and swaps.",
      futures: "CME index, oil and gold futures with a DOM.",
    },
    honest: "Honest conditions",
    honestBody: "The rules of each version are fixed when you buy. No surprise changes, no hidden filters: daily loss, max loss and the day boundary are spelled out.",
    programs: "Programs",
    compare: "Compare",
    size: "Account",
    price: "Price",
    target: "Target",
    dll: "Daily loss",
    ml: "Max loss",
    days: "Min. days",
    split: "Split",
    perMonth: "/ month",
    launch: "launch price",
    configurator: "Configure",
    family: "Program",
    addons: "Add-ons",
    cmeL2: "CME depth (L2)",
    total: "Total",
    rules: "Full rules",
    getStarted: "Get started",
    dayEnds: "Trading day ends {at}",
    rulesHash: "Rules hash {hash}",
    programsLead: "Pick a market, a program and a size. The price and the rules of the version are on the page before you buy.",
    faqLead: "Short answers about accounts, fills and rules.",
    consistency: "Consistency",
    microScalp: "Micro-scalping",
    microScalpNote: "trades held under {sec} s",
    microScalpCell: "≤ {v} % of profit",
    streak: "Before a payout",
    streakCell: "{n} days in a row ≥ {v}",
    daysCell: "{n} days ≥ {v}",
    bestDayCell: "best day ≤ {v} % of profit",
    minProfitCell: "profit ≥ {v}",
    cycle: { weekly: "every 7 days", bi_weekly: "every 14 days", monthly: "every 30 days" },
    fundedOnly: "funded account",
    fairPlay: "Fair play",
    fairPlayCell: "Opposite or hedged positions across accounts are prohibited — your own, other people’s, or accounts with other firms — as are copy and group trading. So are several profiles of one person and latency or price-error arbitrage: linked profiles receive no payouts. Any abuse, scheme or fraudulent practice lets us refuse a payout and close the accounts involved (see Prohibited practices).",
    scaling: "Scaling",
    scalingCell: "+{step} % every {months} months, up to {max}",
    segmentCell: "profit above a payout cap stays on the account",
    carryCell: "profit above a payout cap can be taken later",
    resetCell: "balance back to the start after payout #{n}, then no caps",
    fundingLimit: "Funding limit",
    fundingLimitCell: "{v} per trader on this program",
    daysBar: "a day counts at ≥ {v} % profit",
    tradeLoss: "Max loss per trade",
    tradeLossNote: "an open trade breaches as soon as its floating loss passes it",
    time: "Time limit",
    windowCell: "{h} h from the first trade",
    daysN: "{n} days",
    maxDays: "Max trading days",
    inactivity: "Inactivity",
    inactivityCell: "{n} days without a trade ends the account",
    contracts: "Max contracts",
    contractsCell: "{n} per instrument",
    flat: "Positions closed at",
    flatNote: "{city} time; nothing new until the next session",
    weekend: "Weekend",
    weekendCell: "positions closed Fri 16:55 New York",
    weekendNote: "nothing new until Sun 17:00 New York",
    news: "High-impact news",
    newsCell: "no new trades ±{n} min",
    newsNote: "closing is always allowed",
    faq: "Frequently asked questions",
  },
} as const;
